import { render, staticRenderFns } from "./realignment-items.vue?vue&type=template&id=f1af6f78&"
import script from "./realignment-items.vue?vue&type=script&lang=js&"
export * from "./realignment-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports